import SelectInput from 'CoreComponents/selectInput/';
import { toQueryString } from 'Utils/queryString';
import { redirectTo } from 'Utils/window';

const CLASS_NAME = {
  detailContainerExpanded: 'photographer-profile-info__detail--expanded',
  visible: 'list-package-set__item--visible'
};

const SELECTOR = {
  headerCategorySelect: '#headerCategorySelect',
  asideCategorySelect: '#asideCategorySelect'
};

class PhotographerProfileInfo {
  constructor(elementRef) {
    this._setup();

    // Initialise attributes
    this.elementRef = elementRef;

    this.detailContainer = elementRef.querySelector('.photographer-profile-info__detail');
    this.toggleProfileInfoButton = elementRef.querySelector('.photographer-profile-info__btn-toggle-detail');
    this.categoryBadges = elementRef.querySelectorAll('.list-photographer-category__item');
    this.categorySelectOptions = elementRef.querySelectorAll('.select__options li');

    // Bind functions
    this.toggleProfileInfoButtonClickHandler = this.toggleProfileInfoButtonClickHandler.bind(this);
    this.onVisibleCategoryPackage = this.onVisibleCategoryPackage.bind(this);

    this._addEventListeners();
  }

  // Event Handlers

  /**
   * Event handler when the toggle button is clicked to collapse/expand the detail container
   * on small screens only
   *
   * @param {Event} event - click event
   * */
  toggleProfileInfoButtonClickHandler(event) {
    this.detailContainer.classList.toggle(CLASS_NAME['detailContainerExpanded']);
  }

  onVisibleCategoryPackage(event) {
    const targetElement = event.target || event.srcElement;
    const categoryId = targetElement.id || targetElement.getAttribute('rel');
    this._updateUrlParams(categoryId);
  }

  // Private

  _setup() {
    new SelectInput(document.querySelector(SELECTOR['headerCategorySelect']), {
      addPopper: false
    });

    new SelectInput(document.querySelector(SELECTOR['asideCategorySelect']));
  }

  _addEventListeners() {
    this.toggleProfileInfoButton && this.toggleProfileInfoButton.addEventListener('click', this.toggleProfileInfoButtonClickHandler);

    this.categoryBadges.forEach(categoryBadge => {
      categoryBadge.addEventListener('click', this.onVisibleCategoryPackage);
    });

    this.categorySelectOptions.forEach(categorySelectOption => {
      categorySelectOption.addEventListener('click', this.onVisibleCategoryPackage);
    });
  }

  _updateUrlParams(categoryId) {
    // const urlParams = new URLSearchParams(window.location.search);
    const formData = { 'category_id': categoryId };
    let queryString = toQueryString(formData);
    redirectTo(`${window.location.origin}${window.location.pathname}?${queryString}`);
  }
}

export default PhotographerProfileInfo;



// WEBPACK FOOTER //
// ./engines/vcliq_booking/app/assets/javascripts/vcliq_booking/components/photographerProfileInfo/index.js